export const MEAL_CATEGORIES = ["breakfast", "lunch", "dinner", "snack"];

// Group a flat meals array into the 4 canonical categories, always returning all 4 (even empty).
// Unknown meal_types are dropped (only the 4 canonical slots render).
export function groupMealsByCategory(meals) {
  const list = meals || [];
  const grouped = {};
  for (const mt of MEAL_CATEGORIES) {
    grouped[mt] = list.filter((m) => m.meal_type === mt);
  }
  return grouped;
}

export const MEAL_BORDER_COLORS = {
  breakfast: "border-l-[#E9C46A]",
  lunch: "border-l-[#7B9E7F]",
  dinner: "border-l-[#D4856B]",
  snack: "border-l-[#A5A58D]",
};
